import { GatewayDetails } from '@/models/gateway-details'

export class Gateway{
  id?:  string;
  databaseId?: number
  mac?: string;
  companyId?: string;
  details?: GatewayDetails;

  constructor(params?: Partial<Gateway>) {
    Object.assign(this, params);
  }
}